import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    loading: false,
    currentPage: 1,
    total: 0,
    error: null,
    token: {},
});

const actions = {
    async userReadAll({ commit }, data) {
        try {
            commit('userReadAllBegin');
            const response = await DataService.get(`/users?${new URLSearchParams(data).toString()}`);
            commit('userReadAllSuccess', response.data.data);
        } catch (err) {
            commit('userReadAllErr', err);
        }
    },

    async userAdd({ commit }, payload) {
        try {
            await commit('userAddBegin');
            const response = await DataService.post('/users', payload);
            await commit('userAddSuccess', response.data.data);

            notification.success({
                message: response.data.message,
            });
          } catch (err) {
            await commit('userAddErr', err);

            notification.error({
                message: err.message,
                placement: 'topRight',
            });
          }
    },

    async userUpdate({ commit }, {payload}) {
        try {
            await commit('userUpdateBegin');
            const response = await DataService.put(`/users/${payload.id}`, payload);
            await commit('userUpdateSuccess', response.data.data);

            notification.success({
                message: response.data.message,
            });
          } catch (err) {
            await commit('userUpdateErr', err);
          }
    },

    async userDelete({ commit }, id) {

            await DataService.delete(`/users/${id}`).then((response) => {

                notification.success({
                    message: response.data.message,
                    placement: 'topRight'
                });
            }).catch((error) => {
                console.log(error);
                commit('userDeleteErr', error);
            });
    },

    async userToken({ commit }, payload) {
        await DataService.get(`/external-tokens/user/${payload.userId}`).then((response) => {
            commit('userTokenSuccess', response.data.data);
        }).catch((error) => {
            console.log(error);
            commit('userTokenGetErr', error);
        });
    },

    async userTokenAdd({ commit }, payload) {
        await DataService.post(`/external-tokens`, payload).then((response) => {
            commit('userTokenAddSuccess', response.data.data);

            notification.success({
                message: "Token added successfully.",
                placement: 'topRight'
            });
        }).catch((error) => {
            console.log(error);
            commit('userTokenAddErr', error);
        });
    },

    async userTokenUpdate({ commit }, payload) {
        commit('userTokenUpdateBegin');
        await DataService.put(`/external-tokens/${payload.id}`, payload).then((response) => {
            commit('userTokenUpdateSuccess', response.data.data);
            notification.success({
                message: "Token updated successfully.",
                placement: 'topRight'
            });
        }).catch((error) => {
            console.log(error);
            commit('userTokenUpdateErr', error);
        });
    }
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};